module.exports = __webpack_public_path__ + "static/media/best_me_6.f4651cdc.jpg";